import connectProfile from 'containers/UserPanel/containers/ProfileContainer';
import SampleProfilePage from './SampleProfilePage';

const SampleProfilePageContainer = connectProfile(SampleProfilePage);
export default SampleProfilePageContainer;
